/**
 * i18n工具封装
 * @param key 原装key - 必填
 * @param pageId 页面ID(一般是路径地址, wms.check.material-sn-check ) - 必填
 * @param replaceKey 替换key(当key比较复杂时,properties文件无法解析,就用此key替换) - 选填
 * @returns {string|*} 解析好的数据
 */
export const dic = function (key, replaceKey) {
    // 从路由路径自动组装pageId
    // /wms/stock-task/stock-task -> wms.stock-task.stock-task
    // let path = this.$route.path
    // let pageId = path.replace(/^\/(.*)\//, '$1.').replace(/\//g, '.')
    let i18nKey = (replaceKey === undefined ? key : replaceKey)

    let value = this.$t(i18nKey)
    if (i18nKey !== value) {
        return value
    }
    // 上传操作
    let isUpload = false
    if (isUpload && !isEmpty(key)) {
        // 执行上传操作 uploadDic
        uploadDic(i18nKey, value)
    }

    return key.substr(key.lastIndexOf('.') + 1)
}

function isEmpty (ele) {
    return ele === undefined || ele === ''
}

export const uploadDic = (i18nKey, i18nValue) => {
    console.log(i18nKey, i18nValue)
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js